import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment fullDealProductConfig on ProductConfig {
    limits {
      inWindow {
        dateWindow {
          from
          to
        }
        eventWindow {
          daysAfter
          daysBefore
          type
        }
      }
      overTime {
        maxPrice {
          price {
            currency
            value
          }
          timePeriod
        }
        numberOfItems {
          number
          timePeriod
        }
      }
      perRedemption {
        maxPriceBeforeDiscounts
        minPriceBeforeDiscounts
        numberOfItems
        numberOfProducts
      }
      forOpenValue {
        minValue
        maxValue
      }
    }
    products {
      data {
        externalMetadata {
          openValue
        }
      }
      date
      dateUnix
      locale
      name
      supplier
      type
      uuid
      active
      provider
      vat
      externalIdentifier
      recomRetailPrice
      salePrice {
        currency
        discount
        value
      }
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
